module.exports = __webpack_public_path__ + "static/media/GarmentSteamersbanner.b00b1f85.jpg";